import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonNav } from "@ionic/vue"
  import EditPage from "@/views/talent-profile/EditProfile.vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'EditRoute',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonNav), { root: EditPage }))
}
}

})